import { render, staticRenderFns } from "./DisclaimerModal.vue?vue&type=template&id=c14409bc&"
import script from "./DisclaimerModal.vue?vue&type=script&lang=js&"
export * from "./DisclaimerModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports